import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import LandingPage from '@/pages/LandingPage';
import Dashboard from '@/pages/Dashboard';
import PromptBuilder from '@/pages/PromptBuilder';
import Library from '@/pages/Library';
import DailyChallenge from '@/pages/DailyChallenge';
import Leaderboard from '@/pages/Leaderboard';
import MiniLessons from '@/pages/MiniLessons';
import Badges from '@/pages/Badges';
import Comments from '@/pages/Comments';
import AuthCallback from '@/pages/AuthCallback';
// ImageRemix removed - feature disabled
import PhotoComposer from '@/pages/PhotoComposer';
import AIStudio from '@/pages/AIStudio';
import Subscription from '@/pages/Subscription';
import AdminDashboard from '@/pages/AdminDashboard';
import EmojiStudio from '@/pages/EmojiStudio';
import EmojiAdmin from '@/pages/EmojiAdmin';
import ProtectedRoute from '@/components/ProtectedRoute';
// DailyDrop AI Pages
import DailyDropLanding from '@/pages/DailyDropLanding';
import DailyDropDashboard from '@/pages/DailyDropDashboard';
import DailyDropCreate from '@/pages/DailyDropCreate';
import DailyDropAIGenerator from '@/pages/DailyDropAIGenerator';
import DailyDropSchedule from '@/pages/DailyDropSchedule';
import DailyDropAnalytics from '@/pages/DailyDropAnalytics';
import DailyDropSettings from '@/pages/DailyDropSettings';
import DailyDropReferrals from '@/pages/DailyDropReferrals';
import DailyDropOnboarding from '@/pages/DailyDropOnboarding';
import TermsOfService from '@/pages/TermsOfService';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
// Live Studio
import LiveStudio from '@/pages/LiveStudio';
import LiveStudioCallback from '@/pages/LiveStudioCallback';
import '@/App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/builder" element={<ProtectedRoute><PromptBuilder /></ProtectedRoute>} />
          <Route path="/library" element={<ProtectedRoute><Library /></ProtectedRoute>} />
          <Route path="/challenge" element={<ProtectedRoute><DailyChallenge /></ProtectedRoute>} />
          <Route path="/leaderboard" element={<ProtectedRoute><Leaderboard /></ProtectedRoute>} />
          <Route path="/lessons" element={<ProtectedRoute><MiniLessons /></ProtectedRoute>} />
          <Route path="/badges" element={<ProtectedRoute><Badges /></ProtectedRoute>} />
          <Route path="/comments" element={<ProtectedRoute><Comments /></ProtectedRoute>} />
          {/* ImageRemix route removed - feature disabled */}
          <Route path="/photo-composer" element={<ProtectedRoute><PhotoComposer /></ProtectedRoute>} />
          <Route path="/ai-studio" element={<ProtectedRoute><AIStudio /></ProtectedRoute>} />
          <Route path="/emoji-studio" element={<ProtectedRoute><EmojiStudio /></ProtectedRoute>} />
          {/* Pricing page is public for marketing - shows plans to everyone */}
          <Route path="/pricing" element={<Subscription />} />
          <Route path="/subscription" element={<ProtectedRoute><Subscription /></ProtectedRoute>} />
          <Route path="/subscription/success" element={<ProtectedRoute><Subscription /></ProtectedRoute>} />
          <Route path="/subscription/cancel" element={<ProtectedRoute><Subscription /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/emoji" element={<ProtectedRoute><EmojiAdmin /></ProtectedRoute>} />
          {/* DailyDrop AI Routes */}
          <Route path="/daily-drop/landing" element={<DailyDropLanding />} />
          <Route path="/daily-drop" element={<ProtectedRoute><DailyDropDashboard /></ProtectedRoute>} />
          <Route path="/daily-drop/create" element={<ProtectedRoute><DailyDropCreate /></ProtectedRoute>} />
          <Route path="/daily-drop/ai-generator" element={<ProtectedRoute><DailyDropAIGenerator /></ProtectedRoute>} />
          <Route path="/daily-drop/schedule" element={<ProtectedRoute><DailyDropSchedule /></ProtectedRoute>} />
          <Route path="/daily-drop/analytics" element={<ProtectedRoute><DailyDropAnalytics /></ProtectedRoute>} />
          <Route path="/daily-drop/settings" element={<ProtectedRoute><DailyDropSettings /></ProtectedRoute>} />
          <Route path="/daily-drop/referrals" element={<ProtectedRoute><DailyDropReferrals /></ProtectedRoute>} />
          <Route path="/daily-drop/onboarding" element={<ProtectedRoute><DailyDropOnboarding /></ProtectedRoute>} />
          {/* Legal Pages - Public */}
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          {/* Live Studio - Multistreaming */}
          <Route path="/live-studio" element={<ProtectedRoute><LiveStudio /></ProtectedRoute>} />
          <Route path="/live-studio/callback" element={<ProtectedRoute><LiveStudioCallback /></ProtectedRoute>} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
